module.exports = __webpack_public_path__ + "img/9788983946003.7e90947e.jpg";